/* eslint-disable lines-around-comment */
import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Icon from '../../../base/icons/components/Icon';
import { IconSearch } from '../../../base/icons/svg';
// @ts-ignore
import { getFieldValue } from '../../../base/react';
import BaseTheme from '../../../base/ui/components/BaseTheme.web';
import { MOBILE_BREAKPOINT } from '../../constants';
// @ts-ignore
import { isSpeakerStatsSearchDisabled } from '../../functions';
const useStyles = makeStyles((theme) => {
    return {
        speakerStatsSearchContainer: {
            position: 'relative'
        },
        searchIcon: {
            display: 'none',
            [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
                display: 'block',
                position: 'absolute',
                color: theme.palette.text03,
                left: 16,
                top: 13,
                width: 20,
                height: 20
            }
        },
        speakerStatsSearch: {
            backgroundColor: theme.palette.field01,
            border: '1px solid',
            borderRadius: 6,
            borderColor: theme.palette.ui05,
            color: theme.palette.text01,
            padding: '10px 16px',
            width: '100%',
            height: 40,
            '&::placeholder': Object.assign(Object.assign({ color: theme.palette.text03 }, theme.typography.bodyShortRegular), { lineHeight: `${theme.typography.bodyShortRegular.lineHeight}px` }),
            [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
                height: 48,
                padding: '13px 16px 13px 44px',
                '&::placeholder': Object.assign(Object.assign({}, theme.typography.bodyShortRegularLarge), { lineHeight: `${theme.typography.bodyShortRegular.lineHeightLarge}px` })
            }
        }
    };
});
/**
 * React component for display an individual user's speaker stats.
 *
 * @returns {React$Element<any>}
 */
function SpeakerStatsSearch({ onSearch }) {
    const classes = useStyles();
    const { t } = useTranslation();
    const disableSpeakerStatsSearch = useSelector(isSpeakerStatsSearchDisabled);
    const [searchValue, setSearchValue] = useState('');
    /**
     * Callback for the onChange event of the field.
     *
     * @param {Object} evt - The static event.
     * @returns {void}
     */
    const onChange = useCallback((evt) => {
        const value = getFieldValue(evt);
        setSearchValue(value);
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);
    }, []);
    const preventDismiss = useCallback((evt) => {
        if (evt.key === 'Enter') {
            evt.preventDefault();
        }
    }, []);
    if (disableSpeakerStatsSearch) {
        return null;
    }
    return (React.createElement("div", { className: classes.speakerStatsSearchContainer },
        React.createElement(Icon, { className: classes.searchIcon, color: BaseTheme.palette.icon03, src: IconSearch }),
        React.createElement("input", { autoComplete: 'off', autoFocus: false, className: classes.speakerStatsSearch, id: 'speaker-stats-search', name: 'speakerStatsSearch', onChange: onChange, onKeyPress: preventDismiss, placeholder: t('speakerStats.search'), tabIndex: 0, value: searchValue })));
}
export default SpeakerStatsSearch;
